import Model from '@/models/Model'

export default class HrEmployee extends Model {
    //
    static includes = [
        'hr_finiquito_status',
        'g_user.hr_employee',
        'hr_employee',
    ]
    /**
     *
     */
    resource() {
        return 'hr_finiquito'
    }
}
